import Http from '../../../../http';

const generateMailChimpConnectionUrl = brandId => `/engage/${brandId}/connection`;

// eslint-disable-next-line import/prefer-default-export
export const fetchMailchimpSyncSettings = brandId =>
  Http.get(generateMailChimpConnectionUrl(brandId));

export const saveMailchimpToken = ({ brandId, code }) =>
  Http.post(generateMailChimpConnectionUrl(brandId), {
    code,
  });

export const disconnectFromMailchimp = brandId =>
  Http.delete(generateMailChimpConnectionUrl(brandId));
